import { PreloadedQuery } from 'react-relay';
import type { VariablesOf } from 'relay-runtime';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import GoalAccessPermissionsSettingsAggQuery, {
	type GoalAccessPermissionsSettingsAggQuery as GoalAccessPermissionsSettingsAggQueryType,
} from '../../components/GroupPermissionsSettings/__generated__/GoalAccessPermissionsSettingsAggQuery.graphql';

export const goalAccessPermissionsSettingsResource: RouteResource<
	PreloadedQuery<GoalAccessPermissionsSettingsAggQueryType, Record<string, unknown>>
> = createRelayResource<GoalAccessPermissionsSettingsAggQueryType>({
	getQuery: (_routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		const variables: VariablesOf<GoalAccessPermissionsSettingsAggQueryType> = {
			containerId: context.collabContext?.contextId ?? '',
			isM3GroupPermsEnabled: fg('townsquare_m3_group_permissions'),
			isDefaultAccessLevelEnabled: fg('atlas_enable_goals_default_access_toggle'),
		};

		return {
			query: GoalAccessPermissionsSettingsAggQuery,
			variables,
			environment: getAggRelayEnvironment(),
		};
	},
});
